var NumericalOperator = /* @__PURE__ */ ((NumericalOperator2) => {
  NumericalOperator2["equals"] = "==";
  NumericalOperator2["notEquals"] = "!=";
  NumericalOperator2["greaterThanEquals"] = ">=";
  NumericalOperator2["lessThanEquals"] = "<=";
  NumericalOperator2["greaterThan"] = ">";
  NumericalOperator2["lessThan"] = "<";
  return NumericalOperator2;
})(NumericalOperator || {});
var StringOperator = /* @__PURE__ */ ((StringOperator2) => {
  StringOperator2["startsWith"] = "StartsWith";
  StringOperator2["endsWith"] = "EndsWith";
  StringOperator2["contains"] = "Contains";
  return StringOperator2;
})(StringOperator || {});
export {
  NumericalOperator,
  StringOperator
};
//# sourceMappingURL=SegmentDefinitions.js.map
